import React from 'react'
import Banner, { BannerProps } from './Banner'

const Success = (props: SuccessProps) => <Banner color="#0fc482" {...props} />

export default Success

export interface SuccessProps extends Omit<BannerProps, 'color'> {}
